app.config(function ($stateProvider, $urlRouterProvider) {
	$stateProvider
		.state("login", {
			url: "/login",
			views: {
				main: {
					templateUrl: "app/src/website/landing-page.html",
					controller: "landingPageController",
				},
			},
		})

		.state("reset-password", {
			url: "/resetPassword?token",
			views: {
				main: {
					templateUrl: "app/src/views/reset-password.html",
					controller: "resetController",
				},
			},
		})

		.state("welcome", {
			url: "/welcome",
			views: {
				main: {
					templateUrl: "app/src/views/welcome.html",
					controller: "welcomeController",
				},
			},
		})

		.state("admin-console", {
			url: "/admin-console",
			params: {
				type: "",
				// The role-defaults console opens on this role and points out this permission, when given.
				role: null,
				permission: null,
			},
			views: {
				main: {
					templateUrl: "app/src/views/adminConsole.html",
					controller: "adminController",
				},
			},
		})

		.state("practice-staff", {
			url: "/practice-staff",
			views: {
				main: {
					// Only redirects, into the Settings dialog.
					template: "<div></div>",
					controller: "practiceStaffController",
				},
			},
		})

		.state("pre-op", {
			url: "/pre-op",
			views: {
				main: {
					templateUrl: "app/src/views/pre-op.html",
					controller: "preOpController",
				},
			},
		})

		.state("refer", {
			url: "/refer",
			views: {
				main: {
					templateUrl: "app/src/views/refer.html",
					controller: "referController",
				},
			},
		})

		.state("patient-dashboard", {
			url: "/patientDashboard",
			params: {
				isFromCalendar: false,
			},
			views: {
				main: {
					templateUrl: "app/src/views/patient-dashboard.html",
					controller: "searchController",
				},
			},
		})

		.state("refer.impact", {
			url: "/impact",
			parent: "refer",
			templateUrl: "app/src/views/impact.html",
			controller: "impactController",
		})

		.state("examination", {
			url: "/examination",
			params: {
				isFromReferral: false,
			},
			views: {
				main: {
					templateUrl: "app/src/views/examination.html",
					controller: "examinationController",
				},
			},
		})
		.state("referral", {
			url: "/referral",
			views: {
				main: {
					templateUrl: "app/src/views/referralScreen.html",
					controller: "referralScreenController",
				},
			},
		})
		.state("refer.complete", {
			url: "/complete",
			parent: "refer",
			templateUrl: "app/src/views/complete.html",
			controller: "completeController",
		})

		.state("injection-note", {
			url: "/injectionNote",
			views: {
				main: {
					templateUrl: "app/src/views/injection-note.html",
					controller: "injectionNoteController",
				},
			},
		})

		.state("clinical-note", {
			url: "/clinicalNote",
			views: {
				main: {
					templateUrl: "app/src/views/clinical-note.html",
					controller: "clinicalNoteController",
				},
			},
		})

		.state("operation-note", {
			url: "/operationNote",
			views: {
				main: {
					templateUrl: "app/src/views/operation-note.html",
					controller: "operationNoteController",
				},
			},
		})
		.state("surgery-agreement", {
			url: "/surgeryAgreement",
			views: {
				main: {
					templateUrl: "app/src/js/components/surgeryAgreement/surgeryAgreement.html",
					controller: "surgeryAgreementController",
				},
			},
		})
		.state("medical-certificate", {
			url: "/medicalCertificate",
			params: {
				isReturnToWork: false,
			},
			views: {
				main: {
					templateUrl: "app/src/js/components/medicalCertificate/medicalCertificate.html",
					controller: "medicalCertificateController",
				},
			},
		})
		.state("patient-verification", {
			url: "/patientVerification?token",
			views: {
				main: {
					templateUrl: "app/src/views/patient-verification-form.html",
					controller: "patientVerificationController",
				},
			},
		})
		.state("premium-lens-selection-form", {
			url: "/premiumLensSelection?token",
			views: {
				main: {
					templateUrl: "app/src/views/premium-lens-selection-form.html",
					controller: "premiumLensSelectionFormController",
				},
			},
		})
		.state("features", {
			url: "/features",
			views: {
				main: {
					templateUrl: "app/src/website/features.html",
					controller: "featuresController",
				},
			},
		})
		.state("pricing", {
			url: "/pricing",
			views: {
				main: {
					templateUrl: "app/src/website/pricing.html",
					controller: "pricingController",
				},
			},
		})
		.state("about-us", {
			url: "/about-us",
			views: {
				main: {
					templateUrl: "app/src/website/about-us.html",
					controller: "aboutUsController",
				},
			},
		})
		.state("ai-terms", {
			url: "/ai-terms",
			views: {
				main: {
					templateUrl: "app/src/website/ai-terms.html",
					controller: "aiTermsController",
				},
			},
		})
		.state("clinic-letter",{
			url: "/clinic-letter",
			params: {
				id: null,
				createTemplate: false,
				templateId: null,
				isUpdateTemplateByOthers: false
			},
			views: {
				main: {
					templateUrl: "app/src/js/components/clinicLetter/clinic-letter.html",
					controller: "clinicLetterController",
				},
			},
		})
		.state("error-dashboard", {
			url: "/error-dashboard",
			views: {
				main: {
					templateUrl: "app/src/js/components/errorDashboard/errorDashboard.html",
					controller: "errorDashboardController",
				},
			},
		})
		.state("dicom-viewer", {
			url: "/dicom-viewer",
			views: {
				main: {
					templateUrl: "app/src/js/components/dicomViewer/dicomViewer.html",
					controller: "DicomViewerController",
				},
			},
		})
		.state("custom-form", {
			url: "/customForm?token",
			views: {
				main: {
					templateUrl: "app/src/website/custom-form.html",
					controller: "customFormController",
				},
			},
		})



	$urlRouterProvider.otherwise("/login");
});
